<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 16.5a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 13.5V6"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      clip-rule="evenodd"
      d="M1.28 13.281a1.812 1.812 0 0 1 0-2.56l9.44-9.44a1.808 1.808 0 0 1 2.56 0l9.44 9.44a1.812 1.812 0 0 1 0 2.56l-9.44 9.44a1.811 1.811 0 0 1-2.56 0l-9.44-9.44Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
